export default "__VITE_ASSET__HGa41Ll$__";